import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceTimeline = ({ currentStatus, statusHistory }) => {
  const statuses = [
    { id: 'planned', label: 'Planifié', icon: 'Calendar' },
    { id: 'en_route', label: 'En Route', icon: 'Navigation' },
    { id: 'on_site', label: 'Sur Place', icon: 'MapPin' },
    { id: 'completed', label: 'Terminé', icon: 'CheckCircle' }
  ];

  const getStatusIndex = (status) => {
    return statuses?.findIndex(s => s?.id === status);
  };

  const currentIndex = getStatusIndex(currentStatus);

  const getStatusTime = (statusId) => {
    const history = statusHistory?.find(h => h?.status === statusId);
    return history ? history?.timestamp : null;
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date?.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-sm border border-border">
      <h2 className="text-lg font-semibold text-foreground mb-6">Suivi de votre intervention</h2>
      <div className="relative">
        <div className="absolute top-6 left-0 right-0 h-0.5 bg-muted">
          <div 
            className="h-full bg-primary transition-all duration-500"
            style={{ width: `${(currentIndex / (statuses?.length - 1)) * 100}%` }}
          />
        </div>

        <div className="relative flex justify-between">
          {statuses?.map((status, index) => {
            const isCompleted = index <= currentIndex;
            const isCurrent = index === currentIndex;
            const statusTime = getStatusTime(status?.id);

            return (
              <div key={status?.id} className="flex flex-col items-center" style={{ width: '25%' }}>
                <div 
                  className={`w-12 h-12 rounded-full flex items-center justify-center mb-3 transition-all duration-300 ${
                    isCompleted 
                      ? 'bg-primary text-primary-foreground shadow-md' 
                      : 'bg-muted text-muted-foreground'
                  } ${isCurrent ? 'ring-4 ring-primary/20 scale-110' : ''}`}
                >
                  <Icon 
                    name={status?.icon} 
                    size={20} 
                    color={isCompleted ? '#FFFFFF' : 'currentColor'} 
                  />
                </div>
                <span className={`text-sm font-medium mb-1 text-center ${
                  isCompleted ? 'text-foreground' : 'text-muted-foreground'
                }`}>
                  {status?.label}
                </span>
                {statusTime && (
                  <span className="text-xs text-muted-foreground">
                    {formatTime(statusTime)}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {currentStatus === 'en_route' && (
        <div className="mt-6 p-4 bg-primary/10 rounded-lg flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-foreground">Technicien en route</p>
            <p className="text-xs text-muted-foreground mt-1">
              Votre technicien est en chemin. Vous recevrez une notification à son arrivée.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceTimeline;